// extracted by mini-css-extract-plugin
module.exports = {"dangerous-goods":"dangerous-goods-2z8XIxH","form-item-label":"form-item-label-xyPknaw","form-item-content":"form-item-content-f21152U"};